import { useState } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";

const useHandler = () => {
  const { post } = useApi();
  const { mail, user } = useSingleton();
  const [loading, setLoading] = useState(false);
  const [evaluation, setEvaluation] = useState(null);
  const [showEvaluation, setShowEvaluation] = useState(false);

  const userEmail = mail || user?.data?.email || "";

  const evaluateWriting = async (topic, content, file) => {
    if (!userEmail) return;
    setLoading(true);
    try {
      let res;
      if (file) {
        const formData = new FormData();
        formData.append("topic", topic);
        formData.append("user_mail", userEmail);
        formData.append("file", file);
        res = await post(
          "https://rovianai.com/secure-api/english/writing/evaluate/pdf",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        res = await post(
          "https://rovianai.com/secure-api/english/writing/evaluate",
          { topic, content, user_mail: userEmail }
        );
      }

      if (res?.data) {
        setEvaluation(res.data);
        setShowEvaluation(true);
      }
    } catch (e) {
      console.error("Evaluation Error:", e);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    evaluation,
    showEvaluation,
    setShowEvaluation,
    evaluateWriting,
  };
};

export default useHandler;
